import {PLAN_TYPE_DESTINATION} from '../CreateRecommend/RecommendSourceDestination/constants';
import {
  OVRecommendActionEnum,
  GenerateOVRPotBatchArguments,
} from '../../../schema-types/globalTypes';
import FREQUENCY from '../../../constants/Frequency';
import {RECOMMENDATION_SUBTYPE_TO_SERVER} from '../../../constants/SolutionType';
import {UpsertOvrecommendVariables} from '../../../schema-types/UpsertOvrecommend';
import validateUUID from '../../../utils/validateUUID';
import {
  createOrUpdateSubplan,
  getPotContactId,
  updateRecommendPotsVariables,
  updateRecsVarsProps,
  getIsMinor,
} from './helpers';
import {getPlanFeesServerFromFormik} from '../CreateRecommend/PlanFees';

const getNewVariables = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  contacts = [],
}: updateRecsVarsProps): Promise<UpsertOvrecommendVariables> => {
  const {setUpNew, contact, urgency, urgencyReason} = values;
  const newPlan = setUpNew!.newPlan!;
  const isMinor = getIsMinor(contact, contacts);

  return {
    action: OVRecommendActionEnum.SET_UP_NEW,
    ovrecommendId: validateUUID(ovrecommendId),
    accountId: validateUUID(accountId),
    goalId: validateUUID(goalId),
    isNewPlanRequired: true,
    contactId: getPotContactId(contact, isMinor),
    urgency,
    urgencyReason,
    solutionType: RECOMMENDATION_SUBTYPE_TO_SERVER.PRODUCT_BASED,
    productProviderId: newPlan?.planProvider,
    productNameId: newPlan?.planType,
    parentGuardianId: validateUUID(newPlan?.parentGuardianId),
    note: undefined,
  };
};

export const generateNewOVRPots = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  generateRecommendationPots,
  // updateProtectionPot,
  recommendDetails,
  reviewId,
  contacts = [],
}: updateRecommendPotsVariables) => {
  const {setUpNew, contact, urgency, urgencyReason} = values;
  const newPlan = setUpNew!.newPlan!;
  const isMinor = getIsMinor(contact, contacts);

  const potId = recommendDetails?.pots?.find((x) => !x.pot.parent)?.pot.id;

  {
    const potArgs: GenerateOVRPotBatchArguments[] = [
      {
        planType: PLAN_TYPE_DESTINATION,
        potId: validateUUID(potId),
        isDummy: true,
        reviewId: validateUUID(reviewId),
        mandate: typeof newPlan?.model === 'string' ? newPlan?.model : null,
        modelPortfolioId:
          typeof newPlan?.model === 'string'
            ? null
            : validateUUID(newPlan?.model?.id || ''),
        productProviderId: newPlan?.planProvider,
        productNameId: newPlan?.planType,
        originalOvrId: validateUUID(ovrecommendId),
        inTrust: newPlan?.inTrust,
        contactId: getPotContactId(contact, isMinor),
        fees: getPlanFeesServerFromFormik(newPlan.planFees),
      },
    ];

    if (values.setUpNew?.newPlan?.subplan0?.checked) {
      potArgs.push(
        createOrUpdateSubplan({
          isDummy: true,
          subplanObj: newPlan.subplan0!,

          childPotId: newPlan.subplan0?.existingPotId,
          reviewId,

          frequency: FREQUENCY.SINGLE,
          accountId,
          ovrecommendId,
          contactId: getPotContactId(contact, isMinor),
        })
      );
    }

    if (values.setUpNew?.newPlan?.subplan1?.checked) {
      potArgs.push(
        createOrUpdateSubplan({
          isDummy: true,
          subplanObj: newPlan.subplan1!,

          reviewId,
          childPotId: newPlan.subplan1?.existingPotId,
          frequency: FREQUENCY.SINGLE,
          accountId,
          ovrecommendId,
          contactId: getPotContactId(contact, isMinor),
        })
      );
    }
    await generateRecommendationPots({
      variables: {
        accountId: validateUUID(accountId)!,
        ovrecommendId: validateUUID(ovrecommendId)!,
        args: potArgs,
      },
    });
  }
};

export default getNewVariables;
